import DetailOrder from './DetailOrder.vue';

export default DetailOrder;
